import produce from "immer";
import {
  GET_AFFILIATES_ERROR,
  GET_AFFILIATES_REQUEST,
  GET_AFFILIATES_SUCCESS,
} from "./queries";
import {
  CREATE_AFFILIATE_ERROR,
  CREATE_AFFILIATE_REQUEST,
  CREATE_AFFILIATE_SUCCESS,
} from "./commands";

let initialState = {
  sending: false,
  sent: false,
  fetching: false,
  fetched: false,
  error: "",
};

const affiliates = (state = initialState, action = { type: "" }) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case CREATE_AFFILIATE_REQUEST:
        draft.sending = true;
        draft.error = "";
        break;

      case CREATE_AFFILIATE_SUCCESS:
        draft.sending = false;
        draft.sent = true;
        break;

      case CREATE_AFFILIATE_ERROR:
        draft.sending = false;
        draft.sent = false;
        draft.error = action.error;
        break;

      case GET_AFFILIATES_REQUEST:
        draft.fetching = true;
        draft.fetched = false;
        draft.error = "";
        break;

      case GET_AFFILIATES_SUCCESS:
        draft.data = action.response;
        draft.fetching = false;
        draft.fetched = true;
        draft.error = "";

        break;

      case GET_AFFILIATES_ERROR:
        draft.fetching = false;
        draft.fetched = false;
        draft.error = action.error;

        break;

      default:
        return draft;
    }
  });
};

export default affiliates;
